<template>
  <BaseLayout
    class="layout--onlybranding"
    theme-footer="small"
    hide-navi
  >
    <slot />
  </BaseLayout>
</template>

<script setup lang="ts">
import BaseLayout from '~/components/base-layout.vue';
</script>

<style lang="scss" scoped>
.layout--onlybranding {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  :deep(.layout__container) {
    flex: 1 1 100%;
  }

  :deep(.page-header) {
    position: relative;
  }
}
</style>
